/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 11.04.13
 * Time: 17:10
 */

import { info } from "../logging/info";
import { IOfferDescription } from "./offerDescriptions/IOfferDescription";

/**
 * Dictionary which holds all registered offer descriptions
 */
export class OfferDescriptionDictionary {
    private _dict: Map<any, any>;

    constructor() {
        this._dict = new Map<any, any>();
    }

    /**
     * Adds a new class definition to dictionary out of given offer description object
     * @param offerDescriptionName
     * @param offerDescription
     * @return
     */
    public addEntry(offerDescriptionName: string, offerDescription: IOfferDescription): boolean {
        if (this._dict.get(offerDescriptionName) === undefined) {
            this._dict.set(offerDescriptionName, offerDescription["constructor"]);
        }
        else {
            throw new Error("Offer Description already exists duplicates not allowed. Typename: " + offerDescriptionName);
        }

        return true;
    }

    /**
     * Removes offer description from dictionary
     * @param offerDescriptionName
     * @return
     */
    public removeEntry(offerDescriptionName: string): Object {
        let deleteEntry: Object = this._dict.get(offerDescriptionName);

        if (deleteEntry) {
            this._dict.delete(offerDescriptionName)
        }

        return deleteEntry;
    }

    /**
     * clear all entries
     */
    public clear(): void {
        this._dict = new Map<any, any>();
    }

    /**
     * get offer description class definition from name
     * @param offerDescriptionName
     * @return class definition or null if not found
     */
    public getEntry(offerDescriptionName: string): Object {
        return this._dict.get(offerDescriptionName);
    }

    /**
     * Checks if entry exists
     * @param offerDescriptionName
     * @return
     */
    public hasEntry(offerDescriptionName: string): boolean {
        return this._dict.get(offerDescriptionName) !== undefined;
    }

    public traceAllEntries(): void {
        let key: string;

        info("---- OfferDescriptionDictonary ----");
        for (let key of Array.from(this._dict.keys())) {
            info("      " + key + " ---> " + this._dict.get(key).toString());
        }
    }
}
